/**
 * O RELÓGIO VIVO — "há 43s" que anda sozinho (pedido de 10/09/2026).
 *
 * 🔴 O problema que isto conserta: os tempos relativos ("Última notícia: há
 * 43s", "último teste há 12s") eram calculados no RENDER — e a tela só
 * re-renderizava quando o dado mudava (refetch de 30 s + structural sharing
 * do react-query). O número parecia congelado até um F5.
 *
 * ⚠️ UM relógio por TELA, não um `setInterval` por célula: o hook é usado no
 * componente-pai (a ficha, a página de Indicadores) e o `agora` desce como
 * argumento para `desdeQuando(iso, agora)` — cem células, um tick.
 */
import { useEffect, useState } from 'react';

export function useRelogioVivo(intervaloMs = 1000): number {
  const [agora, setAgora] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setAgora(Date.now()), intervaloMs);
    return () => clearInterval(t);
  }, [intervaloMs]);
  return agora;
}
